  <ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
  <div style="margin-top:60px">
  <div class="card-header" >
    <div class="row">
      <div class="col-12 text-center" style="font-style: open sans; color: #9b7544; ">
        <h4>Adoption Request Form</h4>
      </div>
      </div>
      <div class="row">
          <div class="col-6 text-left" *ngIf="request">
              <span><strong>Contact Sharing: {{request.sharecontact}}</strong></span>
            </div>
      <div class="col-6 text-right" *ngIf="request">
          <span><strong>Form Request Status: {{request.status}}</strong></span>
        </div>
    </div>

  </div>
  <div class="card" style="border:1px,solid;  margin-top:2px">
    <div class="row">
    <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3" >
      <div class="card" style="width:100%; height: 100%" *ngIf="user && user.length > 0">
        <img src="https://passport.petcart.in/images/userimgs/{{user[0].image}}"  style="max-height:200px">
      </div>
    </div>
    <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5  " style="font-style: open sans; font-size:16px" *ngIf="user && user.length > 0">
    <p class=""><span class="headline">Name: </span>{{user[0].name}}</p>
     <!--<p class=""><span class="headline">Bio: </span>{{user[0].bio}}</p>
   <p class=""><span class="headline">Contact:</span> {{user[0].mobile}}</p>
    <p class=""><span class="headline">Email: </span>{{user[0].email}}</p>
    <p class=""><span class="headline">Date Of Birth: </span>{{user[0].dob}}</p>-->
    </div>
    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 " style="font-style: open sans; font-size:16px" *ngIf="adoptionform">
        <div  *ngIf="city">
            <div *ngFor="let data of city">
               <p *ngIf="data.id == adoptionform.city_id"> <span class="headline" >city:</span> {{data.location}}<p>
              </div>
            </div>
      <div  *ngIf="state">
          <div *ngFor="let data of state">
             <p *ngIf="data.id == adoptionform.state_id"> <span class="headline" >State:</span> {{data.name}}</p>
            </div>
      </div>
      <p class=""><span class="headline">Pin:</span>  {{adoptionform.pin}}</p>
      <p class=""><span class="headline">Profession: </span>{{adoptionform.profession}}</p>
      <p class=""><span class="headline">best Time To call: </span>{{adoptionform.timetocall}}</p>
        </div>
    </div>
  </div>
  <mat-tab-group  *ngIf="adoptionform">
      <mat-tab label="Caretaker Detail" >
        <div class="row">
            <div class="col-12 text-left" style="margin-top: 3px">
             <table>
              <tr>
              <th style="color:#9b7544; font-weight:bold;">Question:</th>
              <th style="color:#9b7544; font-weight:bold;">Response</th>
              </tr>
              <tr>
               <td style="overflow-wrap: break-word;font-style: open sans">
                have You owned a pet before?
              </td>
              <td>{{adoptionform.prevpet}}   </td>
           </tr>
            <tr>
            <td style="overflow-wrap: break-word;font-style: open sans">
            If yes Share detail :
            </td>
           <td>{{adoptionform.prevpetdetails}} </td>
           </tr>
           <tr>
           <td style="overflow-wrap: break-word;font-style: open sans">
             Do you currently own any other pets?
            </td>
            <td> {{adoptionform.currentpet}} </td>
            </tr>
           <tr>
          <td style="overflow-wrap: break-word;font-style: open sans">
           If yes Share detail :
          </td>
           <td> {{adoptionform.currentpetdetails}} </td>
          </tr>
          <tr>
         <td style="overflow-wrap: break-word;font-style: open sans">
           Are there any restriction in your house/apartment/villa association for keeping pets?
            </td>
          <td>{{adoptionform.allagree}} </td>
           </tr>
           <tr>
           <td style="overflow-wrap: break-word;font-style: open sans">
            How much time in a day are you willing to provide to the pet?(eg for Training/Wals etc) ?
             </td>
           <td>{{adoptionform.availtime}} </td>
          </tr>
             <tr>
           <td style="overflow-wrap: break-word;font-style: open sans">
             Will you be able to take care of all expenses(medical/food etc) for your adopted pet?
             </td>
             <td>{{adoptionform.expenses}}
             </td>
             </tr>
             <tr>
            <td style="overflow-wrap: break-word;font-style: open sans">
              Are you comfortable with scheduled house checks from our representative or person from
               NGO?
              </td>
            <td>{{adoptionform.housecheck}}
               </td>
              </tr>
            </table>
            </div>
        </div>
        </mat-tab>
        <mat-tab label="Household Information" >
          <div class="row">
            <div class="col-12 text-left" style="margin-top: 3px" >
              <table>


              <tr>
                <th style="color:#9b7544; font-weight:bold;">Question:</th>
                <th style="color:#9b7544; font-weight:bold;">Response</th>
              </tr>

              <tr>
              <td style="overflow-wrap: break-word;font-style: open sans">
                Are all members of your household in agreement on adopting a pet ?
              </td>


              <td>{{adoptionform.allagree}} </td>
              </tr>

              <tr>
              <td style="overflow-wrap: break-word;font-style: open sans">
                  Who will be the primary caretaker of the adopted pet?
              </td>
              <td>{{adoptionform.caretaker}}</td>
              </tr>

              <tr>
              <td style="overflow-wrap: break-word;font-style: open sans">
                    Do You live in a :
              </td>
              <td>{{adoptionform.housetype}}</td>
              </tr>

              <tr>
              <td style="overflow-wrap: break-word;font-style: open sans">
                      Your home is:
              </td>
              <td>{{adoptionform.isrented}}</td>
              </tr>

              <tr>
              <td style="overflow-wrap: break-word;font-style: open sans">
                        Are there any restriction in your house/apartment/villa association for keeping pets?
              </td>
              <td>{{adoptionform.restriction}}</td>
              </tr>

              <tr>
              <td style="overflow-wrap: break-word;font-style: open sans">
                          No ofpeople (in addition to you) in your house:
              </td>
              <td>{{adoptionform.peoplecount}}</td>
              </tr>

              <tr>
              <td style="overflow-wrap: break-word;font-style: open sans">
                            No of children in your house:
              </td>
              <td>{{adoptionform.kidscount}}</td>
              </tr>

              <tr>
              <td style="overflow-wrap: break-word;font-style: open sans">
                              Where will the pet be kept?
              </td>
              <td>{{adoptionform.pethome}}</td>
              </tr>
            </table>

            </div>
          </div>
          </mat-tab>
        </mat-tab-group>
        <div class="card" *ngIf=" request && request.status === 'requested'" style="margin-top:5px">
          <div class="row">
            <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center" style="font-size: 20px">
                <div class="form-check form-check-inline">
                    <div class="radio">
                        <label><input type="radio" name="optradio" value="shortlist" [(ngModel)]= "actiontype">Shortlist</label>
                      </div>
                  </div>
                  <div class="form-check form-check-inline">
                      <div class="radio">
                          <label><input type="radio" name="optradio" value="reject"  [(ngModel)]= "actiontype">Reject</label>
                        </div>
                    </div>
            </div>

          <div class="col-sm-12 col-md-9 col-lg-9 col-xl-9 text-center" style="font-size: 20px" *ngIf="actiontype=== 'shortlist'">

              <div class="form-check form-check-inline">
                  <div class="radio">
                      <label><input type="radio" name="optradio2" value="I will contact Shortly " [(ngModel)] = "contacttype">I will Contact shortly</label>
                    </div>
                </div>
                <div class="form-check form-check-inline">
                    <div class="radio">
                        <label><input type="radio" name="optradio2" value="send my contact details" [(ngModel)] = "contacttype">Send My contact details</label>
                      </div>
                  </div>
                </div>
          </div>
          <div class="row" *ngIf="contacttype==='send my contact details' && actiontype=== 'shortlist'">
            <div class="col-12 text-center">
             <label class="form-check form-check-inline">Contact no:{{mymobile}}</label>
             <label class="form-check form-check-inline"> email:{{myemail}}</label>
            </div>
          </div>
        </div>
        <div class="row" style=" margin-bottom: 4px;margin-top:5px">
          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <button class="btn btn-secondary btn-block" (click)="rejectForm()" *ngIf="actiontype==='reject'">Confirm</button>
            <button class="btn btn-secondary btn-block" (click)="shortlistForm()" *ngIf="actiontype==='shortlist' && contacttype ">Confirm</button>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <button class="btn btn-success2 btn-block" (click)=" goBack()">Go Back</button>
            </div>
        </div>

</div>
